import { environment } from 'src/environments/environment';
import { Injectable } from "@angular/core";
import { constants } from 'src/app/config/constant';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  constructor(public config: constants) {
    this.log = this.log.bind(this)
  }
  log(msg: any, ...params: any) {
    if (this.config.LOGS_ENABLED) {
      console.log.call(console, new Date() + ": ", msg, ...params);
    }
  }
}
